var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"preview",on:{"click":_vm.onClick,"keydown":_vm.onKeydown}},[_c('div',{staticClass:"preview-img"},[_c('img',{attrs:{"src":_vm.src,"alt":""}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/.13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-1c0039d2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/.13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/bigImg.vue
// module id = null
// module chunks = 